import React from 'react';
import { TopbarSearch } from '@/components/ui/TopbarSearch';
import { AuthButton } from '@/core/permissions/AuthButton';
import type { MemberFilters } from '../types/membersList.types';

interface MembersToolbarProps {
  filters: MemberFilters;
  onChange: (filters: MemberFilters) => void;
  onAdd: () => void;
  onExport: () => void;
}

export function MembersToolbar({ filters, onChange, onAdd, onExport }: MembersToolbarProps) {
  return (
    <div className="rounded-md bg-white p-3 shadow-sm border border-slate-100 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-row items-center gap-2 flex-1">
        <div className="flex-1 min-w-0">
          <TopbarSearch
            placeholder="Tìm kiếm..."
            value={filters.query}
            onChange={(query) => onChange({ ...filters, query })}
          />
        </div>
        
        <select
          value={filters.status}
          onChange={(e) => onChange({ ...filters, status: e.target.value as any })}
          className="h-10 shrink-0 rounded-md border border-slate-200 bg-white px-2 text-xs font-medium text-slate-600 outline-none focus:border-emerald-500 w-[110px] sm:w-[160px]"
        >
          <option value="all">Tất cả</option>
          <option value="active">Hoạt động</option>
          <option value="locked">Tạm khóa</option>
          <option value="disabled">Vô hiệu</option>
        </select>
      </div>
      
      <div className="flex flex-row items-center gap-2">
        <AuthButton
          module="users"
          action="view"
          behavior="hide"
          onClick={onExport}
          className="flex h-10 flex-1 items-center justify-center gap-2 rounded-md border border-slate-200 px-4 text-xs font-medium text-slate-600 hover:bg-slate-50 transition-all active:scale-95 lg:flex-none"
        >
          <i className="ri-download-2-line" />
          <span className="truncate">Xuất file</span>
        </AuthButton>

        <AuthButton
          module="users"
          action="create"
          behavior="disable"
          permissionReason="Bạn không có quyền thêm thành viên mới"
          onClick={onAdd}
          className="flex h-10 flex-1 items-center justify-center gap-2 rounded-md bg-emerald-700 px-4 text-xs font-medium text-white hover:bg-emerald-800 transition-all shadow-md shadow-emerald-700/10 active:scale-95 lg:flex-none"
        >
          <i className="ri-add-line" />
          <span className="truncate">Thêm mới</span>
        </AuthButton>
      </div>
    </div>
  );
}
